/*
 * @Author: yuehui
 * @Date: 2019-08-03 09:52:12
 * @LastEditTime: 2019-11-11 17:43:41
 * @LastEditors: yuehui
 * @Description: 到店礼
 */
import request from '@/axios'

// v-1.1.0-01-生成到店礼品码
export function buildGiftCode(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/gift/buildGiftCode',
    method: 'post',
    data
  })
}

// v-1.1.0-02-获取礼品信息
export function getGiftInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/gift/getGiftInfo',
    method: 'post',
    data
  })
}

// v-1.1.0-03-确认领取礼品
export function confirmGiftInfo(data) {
  return request({
    url: process.env.VUE_APP_BASE_API + '/api_rad/gift/confirmGiftInfo',
    method: 'post',
    data
  })
}
